import {createAction} from 'redux-actions';
import {LoginActionParams} from '../LoginTypes';

export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';

export const logInAction = createAction(LOG_IN, async (params: LoginActionParams) => {
    const {jwt} = params;
    
    return {
        jwt,
    };
});

export const logOutAction = createAction(LOG_OUT);
